import { render } from "./dlg-machine.vue?vue&type=template&id=4d79c980"
import script from "./dlg-machine.vue?vue&type=script&lang=js"
export * from "./dlg-machine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__